export default __webpack_public_path__ + "static/media/base-8-min.761f25d2.jpg";